var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRUserPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-user-plus",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c0,-11.038 8.962,-20 20,-20Zm-10.895,29.281l-0.033,0.061c-0.064,0.109 -0.102,0.24 -0.102,0.381c0,0.421 0.341,0.762 0.763,0.762c0.28,0 0.525,-0.151 0.657,-0.377l0.004,-0.006c1.955,-3.337 5.523,-5.543 9.606,-5.543c4.084,0 7.652,2.207 9.579,5.492c-0,0 0.007,0.013 0.028,0.052c0.123,0.236 0.38,0.382 0.66,0.382c0.422,0 0.763,-0.341 0.763,-0.762c-0,-0.141 -0.038,-0.273 -0.105,-0.386c0,0 -0.001,-0.001 -0.001,-0.002l-0,-0c-1.622,-2.755 -4.185,-4.813 -7.237,-5.748c1.552,-0.88 2.739,-2.252 3.366,-3.9l0.018,-0.054c0.03,-0.078 0.047,-0.168 0.047,-0.262c-0,-0.421 -0.342,-0.762 -0.763,-0.762c-0.325,-0 -0.604,0.205 -0.713,0.492l0.031,0.045l-0.031,-0.043l-0.003,0.007c-0.874,2.307 -3.065,3.917 -5.632,3.917c-3.318,0 -6.007,-2.69 -6.007,-6.008c-0,-3.317 2.689,-6.007 6.007,-6.007c0.48,-0 0.947,0.056 1.394,0.163c0,-0 0.004,0 0.005,0c0.017,0.003 0.102,0.018 0.158,0.018c0.421,0 0.763,-0.341 0.763,-0.762c-0,-0.359 -0.239,-0.671 -0.576,-0.739c-0.002,-0.001 -0.002,-0.001 -0.01,-0.003c-0.526,-0.119 -1.124,-0.204 -1.742,-0.204c-4.162,0 -7.535,3.374 -7.535,7.535c-0,2.822 1.551,5.281 3.846,6.572c-3.098,0.968 -5.629,3.014 -7.205,5.689Zm15.213,-16.491c-0,-0 -0,-0 -0,-0c-0,0.421 0.341,0.762 0.762,0.762l1.778,-0c0,-0 -0,1.778 -0,1.778c-0,0.421 0.341,0.762 0.762,0.762c0.421,0 0.763,-0.341 0.763,-0.762c-0,-0 -0,-1.778 -0,-1.778c-0,-0 1.777,-0 1.777,-0c0.421,-0 0.763,-0.341 0.763,-0.762c-0,-0.422 -0.342,-0.763 -0.763,-0.763l-1.778,0c0,0 0.001,-1.778 0.001,-1.778c-0,-0.421 -0.342,-0.762 -0.763,-0.762c-0.421,0 -0.762,0.341 -0.762,0.762c-0,0 -0,1.778 -0,1.778l-1.778,0c-0.421,0 -0.762,0.341 -0.762,0.763Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRUserPlus);
export default __webpack_public_path__ + "static/media/iconR-user-plus.9ec9c5ae5fc5d77497e1b7959c307f3d.svg";
export { ForwardRef as ReactComponent };